export default "__VITE_ASSET__Dcq7KpKx__"